import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Table,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import layout from "antd/lib/layout"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { DateSelect } from "../../../compnents/form/DateSelect"
import { CloseOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons"
import { stringTrim } from "../../../utils/StringUtils"
import FileUpload from "../../../compnents/file/FileUpload"
import Upload, { RcFile } from "antd/lib/upload"
import { UploadFile } from "antd/lib/upload/interface"
import styles from "../filing.module.css"
import axios from "axios"
import { PreviewImgOrPdf } from "../Preview"
import { AXIOS_IP, beforeUploadFile, beforeUploadFileAndImage, customRequest } from "../fileUploadService"

export const CTYXAgainModal = (props: {
  visible: boolean
  token: string
  state: number
  filingType: number
  id?: string
  filingRecordId?: string
  memo?: string
  onOk: () => void
  onCancel: () => void
}) => {
  const { Option } = Select

  const { TextArea } = Input

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [fileList, setFileList] = useState<any>([])

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [previewFile, setPreviewFile] = useState<any>() //预览

  const [detail, setDetail] = useState<any>()

  //参考模板
  const templateData = {
    fileConfigId: "5",
    fileName: "参考模板",
    fileType: "application/pdf",
    filePath:
      "68e0cfd54adf77575a83a2b739bf5ddfa207356d866e9e74b8236c4b070475f8",
  }

  // 自定义上传实现
  const customRequestFn = (options: any, type: string) => {
    customRequest(options, AXIOS_IP, (data: any) => {
      const newurl = {
        fileConfigId: data?.configId,
        fileName: data?.name,
        fileType: data?.type,
        filePath: data?.path,
      }
      switch (type) {
        case "SN":
          setFileList([...fileList, newurl])
          break
      }
    })
  }

  const handleRemove = (type: string, index: number) => {
    switch (type) {
      case "SN":
        setFileList(fileList?.filter((v: any, i: number) => i !== index))
        break
    }
  }
  
  const getData = () => {
      axios({
        url:
          props.state == 2
            ? `${AXIOS_IP}/filingReviewMentor/detail`
            : `${AXIOS_IP}/filingMentor/detail`,
        headers: {
          "Content-Type": "application/json",
          "His-Auth": props.token,
        },
        withCredentials: false,
        method: "POST",
        data: { id: props.state == 1 ? props.filingRecordId :  props.id, filingType: props.filingType },
      }).then((res) => {
        const data = res.data.data
        setDetail(data)
        form.setFieldsValue({
          name: data?.filingApplicantPersonVO?.name,
          techerName: data?.filingGuidanceTeacherVO?.name,
        })
        if(props.state == 2) {
          setFileList(data?.filingFollowLearningVO?.filingStudySituationVOList?.[0]?.lastYearFile)
        }
    })
  }
  

  useEffect(() => {
    form.setFieldsValue({
      lastYearFile: fileList,
    })
  }, [fileList])

  useEffect(() => {
    if (!props.visible) {
      form.resetFields()
      setFileList([])
    } else {
      getData()
    }
  }, [props.visible])

  return (
    <>
      <Modal
        title={props.filingType == 5 ? '传统医学传承管理' : '中医医术确有专长医师管理'}
        width={1000}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={form.submit}
        okText="提交"
        centered
        maskClosable={false}
        confirmLoading={confirmLoading}
      >
        <div>
          <Form
            form={form}
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            style={{ paddingRight: 10 }}
            onFinish={(vs) => {
              setConfirmLoading(true)
              const data = {
                ...vs,
                filingType: props.filingType,
                memo: props.memo,
                filingRecordId: props.filingRecordId,
                reviewRecordId: props.id,
              }
              axios({
                url: `${AXIOS_IP}/filingReviewMentor/restartFiling`,
                headers: {
                  "Content-Type": "application/json",
                  "His-Auth": props.token,
                },
                withCredentials: false,
                method: "POST",
                data,
              })
                .then(() => {
                  notification.success({
                    message: "操作成功",
                  })
                  props.onOk()
                })
                .finally(() => {
                  setConfirmLoading(false)
                })
            }}
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  name="name"
                  label="申报人"
                  rules={[{ required: true }]}
                >
                  <Input allowClear disabled />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="techerName"
                  label="指导老师"
                  rules={[{ required: true }]}
                >
                  <Input allowClear disabled />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="上年度跟师情况"
                  name="lastYearFile"
                  rules={[{ required: true, message: "请上传上年度跟师情况" }]}
                >
                  <Row align="middle">
                    <Upload
                      customRequest={(options) =>
                        customRequestFn(options, "SN")
                      }
                      beforeUpload={(file) => beforeUploadFileAndImage(file, fileList)}
                      showUploadList={false}
                      maxCount={1}
                      accept={".pdf,.jpg,.jpeg,.png,.gif"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    <span style={{ padding: "0 10px 0 15px" }}>
                      支持pdf和图片文件格式上传
                    </span>
                    {/* <a
                      style={{ textDecoration: "underline", paddingRight: 10 }}
                      onClick={() => setPreviewFile(templateData)}
                    >
                      参考模板
                    </a> */}
                    {fileList?.length > 0 &&
                      fileList?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              paddingRight: 10,
                            }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a
                                style={{ paddingLeft: 10 }}
                                onClick={() => setPreviewFile(v)}
                              >
                                查看
                              </a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove("SN", index)
                              }}
                            />
                          </div>
                        )
                      })}
                  </Row>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>

      <PreviewImgOrPdf
        token={props.token}
        AXIOS_IP={AXIOS_IP}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
